function getSelectedOption(e) {

    let options = (e.target && e.target.selectedOptions);
    return (options && options.length && options[0]) || null;

};

function normalizeOptionValue(value) {

    return value == null ? '' : value;

};

function normalizeSelectValue(value) {

    return value === '' ? null : value;

};

function getSelectValue(e) {

    let option = getSelectedOption(e);
    return option ? normalizeSelectValue(option.value) : null;

};

function getSelectData(e) {

    let option = getSelectedOption(e);
    return (option && option._node && option._node.data) || null;

};

function getInputValue(e) {

    return (e.target && e.target.value) || null;

};

function getInputValueInt(e) {

    let value = getInputValue(e),
        parsed = parseInt(value);
    if (isNaN(parsed))
        return null;
    return parsed;

};

function getInputValueFlt(e) {

    let value = getInputValue(e),
        parsed = parseFloat(value);
    if (isNaN(parsed))
        return null;
    return parsed;

};

export {
    normalizeOptionValue,
    normalizeSelectValue,
    getSelectValue,
    getSelectData,
    getInputValue,
    getInputValueInt,
    getInputValueFlt,
    // aliases
    getSelectValue as getComboboxValue,
    getSelectData as getComboboxData,
    getInputValue as getTextboxValue,
    getInputValueFlt as getNumboxValue,
    getInputValueFlt as getNumboxValueFlt,
    getInputValueInt as getNumboxValueInt,
};

